import { render, staticRenderFns } from "./module-caizhi.vue?vue&type=template&id=3e08bc67&scoped=true"
import script from "./module-caizhi.vue?vue&type=script&lang=js"
export * from "./module-caizhi.vue?vue&type=script&lang=js"
import style0 from "./module-caizhi.vue?vue&type=style&index=0&id=3e08bc67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e08bc67",
  null
  
)

export default component.exports